import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=1022c4db&"
import script from "./ThankYou.vue?vue&type=script&lang=ts&"
export * from "./ThankYou.vue?vue&type=script&lang=ts&"
import style0 from "./ThankYou.vue?vue&type=style&index=0&id=1022c4db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports